import CryptoJS from 'crypto-js'

export default {
    /** 加密 **/
    encrypt(word){
        let timestamp = new Date().getTime() + '';
        timestamp = timestamp + timestamp.substr(10,3);
        let timestamps = CryptoJS.enc.Utf8.parse(timestamp);

        let encrypted = CryptoJS.AES.encrypt(word, timestamps, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        let tokenStr = encrypted.ciphertext.toString();

        tokenStr = timestamp + "|" + tokenStr;

        let keyHex = CryptoJS.enc.Utf8.parse("SUlCkXjyLv8cftAu")
        let encrypteds = CryptoJS.AES.encrypt(tokenStr, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypteds.ciphertext.toString();
    },

    /** 解密 **/
    decrypt(word){
        let key = CryptoJS.enc.Utf8.parse('1234567890ABCDEF');
        let decrypt = CryptoJS.AES.decrypt(word, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
}